import Validator from './validator.js';

export default class CheckedInEachValidator extends Validator {
    constructor(input) {
        super(input);
        this.type = this.input.el.type;
        this.field = this.input.parent;
        this.form = this.field.parent;
    }

    valid() {
        const others = this.input.el.dataset.checkedInEach?.split(",")?.map(o => this.form.field(o.trim()))?.filter(o => o) || [];
        const fields = [ this.field, ...others ];
        if(fields.length > 1) {
            const fieldsChecked = fields.map(f => {
                return {
                    field: f,
                    checked: f.inputs.filter(i => i.el.type === 'checkbox').some(i => i.el.checked),
                }
            });
            const anyFieldsChecked = fieldsChecked.map(fc => fc.checked).reduce((a, b) => a || b);
            const anyCurrentChecked = this.field.inputs.filter(i => i.el.type === 'checkbox').some(i => i.el.checked);
            fieldsChecked.forEach(fc => fc.field.toggle(!anyFieldsChecked || fc.checked));
            return Promise.resolve(!anyFieldsChecked || anyCurrentChecked);
        } else {
            return Promise.resolve(true);
        }
    }

    static applies(input) {
        return input.el.dataset.checkedInEach !== undefined;
    }
}
